/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type ExpertRendererQueryVariables = {};
export type ExpertRendererQueryResponse = {
    readonly v2: {
        readonly viewer: {
            readonly user: {
                readonly consultant: {
                    readonly lifecycle: {
                        readonly basicProfileCompleted: boolean | null;
                    } | null;
                } | null;
                readonly profilePicture: {
                    readonly source: string;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type ExpertRendererQuery = {
    readonly response: ExpertRendererQueryResponse;
    readonly variables: ExpertRendererQueryVariables;
};



/*
query ExpertRendererQuery {
  v2 {
    viewer {
      user {
        consultant {
          lifecycle {
            basicProfileCompleted
            id
          }
          id
        }
        profilePicture(size: LARGE) {
          source
        }
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "basicProfileCompleted",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "profilePicture",
        "storageKey": "profilePicture(size:\"LARGE\")",
        "args": [
            {
                "kind": "Literal",
                "name": "size",
                "value": "LARGE"
            }
        ],
        "concreteType": "ProfilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "source",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ExpertRendererQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "v2",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "V2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "viewer",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ViewerV2",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "consultant",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ConsultantV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "lifecycle",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Lifecycle",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        (v1 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "ExpertRendererQuery",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "v2",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "V2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "viewer",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ViewerV2",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "consultant",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ConsultantV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "lifecycle",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Lifecycle",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ]
                                                },
                                                (v2 /*: any*/)
                                            ]
                                        },
                                        (v1 /*: any*/),
                                        (v2 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "ExpertRendererQuery",
            "id": null,
            "text": "query ExpertRendererQuery {\n  v2 {\n    viewer {\n      user {\n        consultant {\n          lifecycle {\n            basicProfileCompleted\n            id\n          }\n          id\n        }\n        profilePicture(size: LARGE) {\n          source\n        }\n        id\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '76453cfe43585a860a9adae2d6c6dfea';
export default node;
